module.exports = __webpack_public_path__ + "img/pagination.bfeaec19.png";